/**
 * On-Device Reminders — type picker popup (FEAT-REMINDERS-001).
 * Opened from "New reminder" (list) and "Change type" (editor). Mirrors the design
 * canvas dialog "What should time this reminder?" — 8 cards / 7 types in a 2-col grid.
 * Popups, not drawers (house rule).
 */
import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
  Button, SimpleGrid, Box, Text,
} from '@chakra-ui/react';
import { FiCalendar, FiShoppingCart, FiRepeat, FiMoon, FiClock, FiSmartphone, FiUser, FiAward } from 'react-icons/fi';
import './reminders.css';

export const TYPE_CARDS = [
  { key: 'event:before', type: 'event', mode: 'before', icon: FiCalendar, label: 'Event date', desc: 'From a date your app reports. 24 hours before a bundle expires.' },
  { key: 'event:after', type: 'event', mode: 'after', icon: FiShoppingCart, label: 'After an event happens', desc: "Unfinished actions. 2 hours after checkout starts, unless it's completed." },
  { key: 'schedule', type: 'schedule', icon: FiRepeat, label: 'Repeating schedule', desc: 'Fixed times. Every day at 9 PM, or every Friday at 6 PM.' },
  { key: 'prayer', type: 'prayer', icon: FiMoon, label: 'Prayer and Islamic calendar', desc: 'Calculated on the phone. 10 minutes before each prayer, Iftar in Ramadan.' },
  { key: 'inactivity', type: 'inactivity', icon: FiClock, label: 'App not opened', desc: 'When the user stays away. After 7 days without opening the app.' },
  { key: 'first_open', type: 'first_open', icon: FiSmartphone, label: 'Since first open', desc: 'Onboarding steps. Day 3 after the app is first opened.' },
  { key: 'profile', type: 'profile', icon: FiUser, label: 'Profile date', desc: "A date on the contact. On the customer's birthday, every year." },
  { key: 'milestone', type: 'milestone', icon: FiAward, label: 'App usage milestone', desc: 'Counted on the phone. On the 3rd app open, or the 5th top-up.' },
];

export default function ReminderTypePicker({ isOpen, onClose, onPick, changing = false }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="16px">
        <ModalHeader fontSize="18px">What should time this reminder?</ModalHeader>
        <ModalCloseButton />
        <ModalBody className="rm-scope" style={{ minHeight: 0, background: 'transparent' }}>
          {changing && (
            <Text color="orange.600" fontSize="13px" mb={3}>
              Changing the type resets the Timing settings. Name, audience and message stay.
            </Text>
          )}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing="10px">
            {TYPE_CARDS.map((c) => {
              const IconC = c.icon;
              return (
                <Box key={c.key} as="button" type="button" className="rm-tcard" onClick={() => onPick(c)}>
                  <span className="rm-ti"><IconC size={18} /></span>
                  <span><span className="rm-tt">{c.label}</span><span className="rm-tx">{c.desc}</span></span>
                </Box>
              );
            })}
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" size="sm" onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
